import { deliveryType } from '../types';
import moment from 'moment';

export const filterByStatus = (data: Array<object>, status: string) => {
    const _filter = data.filter((item: any) => item.status === status);
    return _filter;
};

export const filterByRole = (data: Array<object>, role: string) => {
    const _filter = data.filter((item: any) => item.role === role);
    return _filter;
};

export const checkIfKeyExist = (objectName: object, keyName: string) => {
    const keyExist = Object.keys(objectName).some(key => key === keyName);
    return keyExist;
};

export const getPreviousDay = (numberOfDays: number) => moment().subtract(numberOfDays, 'days').format('YYYY-MM-DD');

export const getPreviousWeek = (numberOfWeeks: number) => moment().subtract(numberOfWeeks, 'weeks').startOf('week').format('YYYY-MM-DD');

export const getPreviousMonth = (numberOfMonths: number) => moment().subtract(numberOfMonths, 'months').startOf('months').format('YYYY-MM-DD');

export const getTotal = (deliveries: Array<deliveryType>) => deliveries?.filter((delivery: any) => delivery.status === 'delivered').reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

export const getTodayTotal = (deliveries: Array<deliveryType>) => deliveries?.filter((delivery: deliveryType) => delivery.status === 'delivered' && moment(delivery.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')).reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);